import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { MultiSelect, Option } from 'react-multi-select-component';
import { useDispatch, useSelector } from 'react-redux';
import { MediaProps } from 'reactstrap';
import { Button, Text, useColorMode } from 'theme-ui';
import * as Yup from 'yup';
import { CreateUserForm, RootState } from '../../../../@types';
import { mediaUpload } from '../../../store/actions/media.action';
import { getAllRoles, getAllUserWithoutPagination } from '../../../store/actions/user.action';
import theme from '../../../theme';
import { useNavigate } from 'react-router-dom';
import { ActionCreateByUrl } from '../../../store/actions/CommonAction';
import { skills } from '../../../utils/constent';
import { handleDepartmentChange } from '../../../utils/userDepartmentHelper';
const genders: string[] = ['Male', 'Female', 'Other'];
const validationSchema = Yup.object().shape({
  FirstName: Yup.string().required('First Name is required'),
  LastName: Yup.string().required('Last Name is required'),
  timeZone: Yup.string().required('Time zone is required'),
  userTeam: Yup.string().required('User Team is required'),
  // ReportingManager: Yup.string().required('Reporting Manager Name is required'),
  Email: Yup.string().email('Invalid email address').required('Email is required'),
  // Gender: Yup.string().required('Gender is required'),
  Role: Yup.array().of(Yup.string()).required('Role is required').min(1, 'At least one role must be selected'),
  // CanManageTo: Yup.array().of(Yup.string()).required('CanManageTo is required').min(1, 'At least one CanManageTo must be selected'),
  // TypeOfSkills: Yup.array().of(Yup.string()).required('Skills is required').min(1, 'At least one skills must be selected'),
  Password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
      'Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character'
    ),
  PhoneNumber: Yup.string().matches(
    /^[0-9]+$/,
    "Only digits are allowed!!"
  ).min(10, 'Phone number must be at least 10 digits')
    .max(11, 'Phone number must not exceed 11 digits'),
  officeNumber: Yup.string().matches(
    /^[0-9]+$/,
    "Only digits are allowed!!"
  ).min(10, 'Office number must be at least 10 digits')
    .max(11, 'Office number must not exceed 11 digits'),
  joiningDate: Yup.date()
    .max(new Date(), 'Joining date cannot be in the future')
    .required('Joining date is required'),
  RePassword: Yup.string()
    .oneOf([Yup.ref('Password')], 'Passwords must match')
    .required('Re-Enter Password is required'),
  departments: Yup.array().of(Yup.string()).required('Department is required').min(1, 'At least one department must be selected'),
});

const CreateUser: React.FC = () => {
  const navigate = useNavigate();
  const roles = useSelector((state: RootState) => state.user.roles);
  const { uploadedMedia } = useSelector((state: MediaProps) => state?.media);
  // const media = useSelector((state: MediaProps) => state.data)
  // const { roles } = useSelector((state: RootState) => state.user);

  const userData = useSelector((state: any) => state?.user);
  const [colorMode] = useColorMode();
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const { createprojectMasterData } = useSelector((state: any) => state.project)


  const Users = userData?.userData?.data;
  const dispatch = useDispatch();
  const initialValues: CreateUserForm = {
    _id: '',
    FirstName: '',
    LastName: '',
    Gender: '',
    Email: '',
    Role: [],
    Password: '',
    RePassword: '',
    TypeOfSkills: [],
    ReportingManager: '',
    CanManageTo: [],
    ProfileImage: uploadedMedia || '',
    PhoneNumber: '',
    officeNumber: '',
    timeZone: '',
    userTeam: '',
    joiningDate: '',
    departments: []
  };
  useEffect(() => {
    dispatch(getAllRoles());
    // dispatch(getAllUser(paginations))
    dispatch(getAllUserWithoutPagination())
  }, [dispatch]);
  const handleProfileImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = (event.target.files as FileList)[0];
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', 'user');
      formData.append('uploadType', 'File');
      dispatch(mediaUpload(formData));
    } else {
      console.warn('Profile Image not found!');
    }
  };
  const handleSubmit = async (payload: any) => {
    payload.ProfileImage = uploadedMedia || '';

    if (!payload.ReportingManager) {
      delete payload?.ReportingManager;
    }

    if (payload.PhoneNumber && Number(payload.PhoneNumber) !== 0) {
      payload.PhoneNumber = Number(payload.PhoneNumber);
    } else {
      payload.PhoneNumber = null;
    }

    if (payload.officeNumber && Number(payload.officeNumber) !== 0) {
      payload.officeNumber = Number(payload.officeNumber);
    } else {
      payload.officeNumber = null;
    }

    const { _id, ...payloadWithoutId } = payload;

    dispatch(ActionCreateByUrl({ Query: "users/CreateUser", obj: payloadWithoutId }, (res: any) => {
      navigate("/user");
    }));
  };
  const TypeOfSkills: Option[] = skills?.map((value) => ({
    label: value?.label,
    value: value?.value,
  }))
  const canManageToOptions: Option[] = Users?.map((user: any) => ({
    label: user?.FirstName || 'unknown',
    value: user?._id,
  }));
  const roleOptions: Option[] = roles?.data?.map((roles) => ({
    label: roles?.RoleName || 'unknown',
    value: roles?._id,
  }));
  const userTeam = [
    { label: 'PEC', value: 'PEC' },
    { label: 'QDC', value: 'QDC' },
  ]
  const timeZones = [
    { label: 'PST', value: 'America/Los_Angeles' },
    { label: 'IST', value: 'Asia/Calcutta' },
  ]
  const departments: Option[] = Array.isArray(createprojectMasterData?.allDepartments?.data) ? createprojectMasterData?.allDepartments?.data.map((departments: any) => ({
    label: departments?.name || 'unknown',
    value: departments?._id,
  })) : [];

  return (
    <div className="main-content px-3" >

      <h1 style={{ color: colorMode === "light" ? "black" : "white" }}>Add User</h1>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}

      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form>
            {/* <div className='container-fluid'> */}
            <div className="row">
              <div className="col-md-4 mt-4">
                <label htmlFor="FirstName" style={{ color: colorMode === "light" ? "black" : "white" }} className={`form-label mt-1 ${errors.FirstName && touched.FirstName ? 'is-invalid' : ''}`}>First Name<span className="text-danger">*</span></label>
                <Field type="text" id="FirstName" name="FirstName" className="form-control" placeholder="First Name" />
                <ErrorMessage name="FirstName" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="LastName" style={{ color: colorMode === "light" ? "black" : "white" }} className={`form-label mt-1 ${errors.LastName && touched.LastName ? 'is-invalid' : ''}`}>Last Name<span className="text-danger">*</span></label>
                <Field type="text" id="LastName" name="LastName" className="form-control" placeholder="Last Name" />
                <ErrorMessage name="LastName" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="userEmail" style={{ color: colorMode === "light" ? "black" : "white" }} className={`form-label mt-1 ${errors?.Email && touched?.Email ? 'is-invalid' : ''}`}>Email ID<span className="text-danger">*</span></label>
                <Field type="text" id="userEmail" name="Email" className="form-control" placeholder="Email ID" autoComplete="off" />
                <ErrorMessage name="Email" component="div" className="text-danger" />
              </div>
              {/* <div className="col-md-4 mt-4">
                <label htmlFor="Project" className="form-label">Project<span className="text-danger">*</span></label>
                <Field type="text" id="Project" name="Project" className="form-control" placeholder="Project" />
                <ErrorMessage name="Project" component="div" className="text-danger" />
              </div> */}
              <div className="col-md-4 mt-4">
                <label htmlFor="Gender" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">
                  Gender<span className="text-danger">*</span>
                </label>
                <Field
                  as="select"
                  id="Gender"
                  name="Gender"
                  className={`form-control `}
                  // onChange={(e) => setFieldValue('Gender', e.target.value)}
                  value={values.Gender}
                >
                  <option value="" label="Select Gender" />
                  {genders?.map((gender) => (
                    <option key={gender} value={gender} label={gender} />
                  ))}
                </Field>
                {/* <ErrorMessage name="Gender" component="div" className="text-danger" /> */}
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="Role" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Role Name<span className="text-danger">*</span></label>
                {roleOptions?.length > 0 && <MultiSelect
                  options={roleOptions}
                  value={(values?.Role || [])?.map((value: any) => roleOptions?.find((option) => option?.value === value) as Option)}
                  onChange={(selected: Option[]) => setFieldValue('Role', selected?.map((option) => option?.value))}
                  labelledBy="Select"
                />}
                {errors?.Role && touched?.Role ? (
                  <Text variant="Inter15Regular30lh" className="text-danger" sx={{ my: '5px', minHeight: '11px', lineHeight: '10px' }}>
                    {errors?.Role}
                  </Text>
                ) : (
                  null
                )}
                {/* <Field
                  as="select"
                  id="Role"
                  name="Role"
                  className="form-control"
                >
                  <option value="" label="Select Role" />
                  {roles && roles?.data.map((role: any) => (
                    <option key={role._id} value={role._id} label={role.RoleName} />
                  ))}
                </Field> */}
                {/* <ErrorMessage name="Role" component="div" className="text-danger" /> */}
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="PhoneNumber" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Phone Number</label>
                <Field type="text" id="PhoneNumber" name="PhoneNumber" className="form-control" placeholder="Phone Number" />
                <ErrorMessage name="PhoneNumber" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="officeNumber" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Office Number</label>
                <Field type="text" id="officeNumber" name="officeNumber" className="form-control" placeholder="Office Number" />
                <ErrorMessage name="officeNumber" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="ReportingManager" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Reporting Manager</label>
                <Field
                  as="select"
                  id="ReportingManager"
                  name="ReportingManager"
                  className={`form-control`}
                >
                  <option value="" label="Select Reporting Manager" />
                  {Users?.map((user: any) => (
                    <option key={user?._id} value={user?._id} label={user?.FirstName} />
                  ))}
                </Field>
                {/* <ErrorMessage name="ReportingManager" component="div" className="text-danger" /> */}
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="CanManageTo" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Can Manage to</label>
                {canManageToOptions?.length > 0 && <MultiSelect
                  options={canManageToOptions}
                  value={values?.CanManageTo?.map((value) => canManageToOptions?.find((option) => option?.value === value) as Option)}
                  onChange={(selected: Option[]) => setFieldValue('CanManageTo', selected?.map((option) => option?.value))}
                  labelledBy="Select"
                />}
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="TypeOfSkills" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Types of Skills</label>
                {TypeOfSkills?.length > 0 && <MultiSelect
                  options={TypeOfSkills}
                  value={values?.TypeOfSkills?.map((value) => TypeOfSkills.find((option) => option?.value === value) as Option)}
                  onChange={(selected: Option[]) => setFieldValue('TypeOfSkills', selected?.map((option) => option?.value))}
                  labelledBy="Select"
                />}
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="userPassword" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Enter Password<span className="text-danger">*</span></label>
                <div style={{ position: 'relative' }}>
                  <Field type={showPassword ? "text" : "password"} id="userPassword" name="Password" className="form-control" placeholder="Enter Password" style={{ paddingRight: '38px' }} />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      color: '#888',
                      display: 'flex',
                      alignItems: 'center',
                      zIndex: 2,
                    }}
                  >
                    {showPassword ? <FiEye size={18} /> : <FiEyeOff size={18} />}
                  </span>
                </div>
                <ErrorMessage name="Password" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="RePassword" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">
                  Re-Enter Password<span className="text-danger">*</span>
                </label>
                <div style={{ position: 'relative' }}>
                  <Field
                    type={showRePassword ? "text" : "password"}
                    id="RePassword"
                    name="RePassword"
                    className="form-control"
                    placeholder="Re-Enter Password"
                    style={{ paddingRight: '38px' }}
                  />
                  <span
                    onClick={() => setShowRePassword(!showRePassword)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      color: '#888',
                      display: 'flex',
                      alignItems: 'center',
                      zIndex: 2,
                    }}
                  >
                    {showRePassword ? <FiEye size={18} /> : <FiEyeOff size={18} />}
                  </span>
                </div>
                <ErrorMessage name="RePassword" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="userTeam" className="form-label" style={{ color: colorMode === "light" ? "black" : "white" }}>User Team<span className="text-danger">*</span></label>
                <Field
                  as="select"
                  id="userTeam"
                  name="userTeam"
                  className={`form-control`}
                >
                  <option value="" label="Select User Team" />
                  {userTeam?.map((user: any, index: number) => (
                    <option key={index} value={user.value} label={user.label} />
                  ))}
                </Field>
                <ErrorMessage name="userTeam" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="timeZone" className="form-label" style={{ color: colorMode === "light" ? "black" : "white" }}>Time Zone<span className="text-danger">*</span></label>
                <Field
                  as="select"
                  id="timeZone"
                  name="timeZone"
                  className={`form-control`}
                >
                  <option value="" label="Select Time Zone" />
                  {timeZones?.map((user: any, index: number) => (
                    <option key={index} value={user?.value} label={user?.label} />
                  ))}
                </Field>
                <ErrorMessage name="timeZone" component="div" className="text-danger" />
              </div>
              <div className='col-md-4 mt-4'>
                <label htmlFor='joiningDate' className="form-label" style={{ color: colorMode === "light" ? "black" : "white" }}>Joining Date<span className="text-danger">*</span></label>
                <Field type="date" id="joiningDate" name="joiningDate" className="form-control" placeholder="Enter Date" />
                <ErrorMessage name="joiningDate" component="div" className="text-danger" />

              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="departments" className="form-label" style={{ color: colorMode === "light" ? "black" : "white" }}>Department<span className="text-danger">*</span></label>
                {departments?.length > 0 && (
                  <div title={(values?.departments || []).map((value: any) => departments?.find((option) => option?.value === value)?.label).filter(Boolean).join(', ')}>
                    <MultiSelect
                      options={departments}
                      value={values?.departments?.map((value: any) => departments?.find((option) => option?.value === value) as Option)}
                      onChange={(selected: Option[]) => {
                        const updatedDepartments = handleDepartmentChange(selected, values?.departments || [], departments);
                        setFieldValue('departments', updatedDepartments);
                      }}
                      labelledBy="Select"
                    />
                  </div>
                )}
                {touched.departments && typeof errors.departments === 'string' && (
                  <Text
                    variant="Inter15Regular30lh"
                    className="text-danger"
                    sx={{ my: '5px', minHeight: '11px', lineHeight: '10px' }}
                  >
                    {errors.departments}
                  </Text>
                )}

              </div>
              <div className='col-md-12 mt-4' style={{ color: colorMode === "light" ? "black" : "white" }}><h2>System Field</h2></div>
              <div className='col-md-4 mt-4'>
                <label htmlFor='ProfileImage' style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Profile Image</label>
                <input
                  type="file"
                  id="ProfileImage"
                  name="ProfileImage"
                  onChange={handleProfileImageChange}
                  className={`form-control ${errors.ProfileImage && touched.ProfileImage ? 'is-invalid' : ''}`}
                />
              </div>
              <div className='col-md-4 mt-4'>
                <label htmlFor='Evaluation' style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Next Evaluation</label>
                <Field type="date" id="Evaluation" name="Evaluation" className="form-control" placeholder="Enter Date" />
              </div>
            </div>
            <div className='row mt-5'>
              <div className='col-md-4'></div>
              <div className='col-md-4'><Button type="reset" sx={{ border: `1px solid ${theme.colors?.primary || 'defaultBorderColor'}`, background: 'white', color: theme.colors?.muted, borderRadius: '12px', padding: [2, 4, 2, 4], width: '95%' }} onClick={() => navigate(-1)}> Cancel </Button></div>
              <div className='col-md-4'><Button sx={{ borderRadius: '12px', padding: [2, 4, 2, 4], width: '95%' }} type='submit'>Submit</Button></div>
            </div>
          </Form>)}
      </Formik>
    </div >
  );
};

export default CreateUser;
